// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前管理员信息 GET /api/admin/current */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    code: number;
    message: string;
    data: API.CurrentUser;
  }>('/api/admin/current', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/admin/logout */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/admin/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 管理员登录接口 POST /api/admin/login */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/admin/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      email: body.email || body.username, // 兼容username字段
      password: body.password,
    },
    skipErrorHandler: true, // 跳过全局错误处理，由登录页面自行处理
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
